import AlcoholPercentage from './AlcoholPercentage';
import FadKobling from './FadKobling';
import SalesPrice from './SalesPrice';

export {
  AlcoholPercentage,
  FadKobling,
  SalesPrice,
};
